import React from 'react';
import BarChartOutlinedIcon from '@material-ui/icons/BarChartOutlined';
import TimelineOutlinedIcon from '@material-ui/icons/TimelineOutlined';
import NotFound from './pages/errors/NotFound';
import NotificationsActiveOutlinedIcon from '@material-ui/icons/NotificationsActiveOutlined';

import {
  Algos as AlgosIcon,
  OrderBookOutline as OrderBookOutlineIcon,
} from './components/Icons';

const SignIn = React.lazy(() => import('./pages/authentication/SignIn'));

const PreLogin = React.lazy(() => import('./pages/authentication/PreLogin'));

const PreLoginConsent = React.lazy(() =>
  import('./pages/authentication/PreLoginConsent')
);

const AccountSettings = React.lazy(() =>
  import(
    /* webpackChunkName: "account-settings" */ './pages/AccountSettings/AccountSettings'
  )
);

// General
const TermsConditions = React.lazy(() =>
  import(
    /* webpackChunkName: "terms-conditions" */ './pages/general/TermsConditions'
  )
);

const PrivacyPolicy = React.lazy(() =>
  import(
    /* webpackChunkName: "privacy-policy" */ './pages/general/PrivacyPolicy'
  )
);

const RefundPolicy = React.lazy(() =>
  import(/* webpackChunkName: "refund-policy" */ './pages/general/RefundPolicy')
);

const AlgosList = React.lazy(() =>
  import(/* webpackChunkName: "algos-list" */ './pages/AlgosList')
);

const AlgoConfigEdit = React.lazy(() =>
  import(/* webpackChunkName: "algo-config-edit" */ './pages/AlgoConfigEdit')
);

const CreateAlgo = React.lazy(() =>
  import(/* webpackChunkName: "algo-config-edit" */ './pages/CreateAlgo')
);

const Reports = React.lazy(() =>
  import(/* webpackChunkName: "reports" */ './pages/Reports')
);

const PnlChart = React.lazy(() =>
  import(/* webpackChunkName: "pnl-chart" */ './pages/PnlChart/Main')
);

const userOrderBookIndexPage = React.lazy(() =>
  import(
    /* webpackChunkName: "user-order-book-index-page" */ './pages/order-book/index'
  )
);

const Subscription = React.lazy(() =>
  import(/* webpackChunkName: "subscription" */ './pages/Subscription')
);

const BillingAndPayment = React.lazy(() =>
  import(
    /* webpackChunkName: "billing-and-payment" */ './pages/BillingAndPayment'
  )
);

const NotificationAlerts = React.lazy(() =>
  import(
    /* webpackChunkName: "notification-alerts" */ './pages/NotificationAlerts'
  )
);

const FamilyLoginSuccess = React.lazy(() =>
  import('./pages/authentication/FamilyLoginSuccess')
);

const Brokers = React.lazy(() => import('./pages/Brokers'));

const AlgoBulkErrorRetry = React.lazy(() =>
  import('./pages/AlgoBulkErrorRetry/AlgoBulkErrorRetry')
);

const CustomerSupport = React.lazy(() =>
  import('./pages/general/CustomerSupport')
);

const routes = [
  {
    id: 'algos',
    path: '/algos',
    exact: true,
    name: 'Algos',
    component: AlgosList,
    icon: AlgosIcon,
  },
  {
    id: 'algo-edit',
    path: '/algos/:id',
    name: 'Algos config edit',
    component: AlgoConfigEdit,
    excludeFromSidebar: true,
  },
  {
    id: 'create-algo',
    exact: true,
    path: '/create-algo',
    name: 'Create Algo',
    component: CreateAlgo,
    excludeFromSidebar: true,
  },
  {
    id: 'pnl-chart',
    path: '/pnl-chart',
    name: 'P&L Chart',
    component: PnlChart,
    exact: true,
    icon: TimelineOutlinedIcon,
  },
  {
    id: 'account-settings',
    path: '/account-settings',
    exact: true,
    name: 'My Account',
    component: AccountSettings,
    excludeFromSidebar: true,
  },
  {
    id: 'Subscription',
    path: '/subscriptions',
    exact: true,
    name: 'Subscription',
    component: Subscription,
    excludeFromSidebar: true,
  },
  {
    id: 'billing-payment',
    path: '/billing',
    exact: true,
    name: 'Billing And Payment',
    component: BillingAndPayment,
    excludeFromSidebar: true,
  },

  {
    id: 'sign-in',
    path: '/auth',
    name: 'Sign In',
    exact: true,
    component: SignIn,
    excludeFromSidebar: true,
  },
  {
    id: 'pre-login-consent',
    path: '/auth/pre-login-consent',
    name: 'Pre Login Consent',
    exact: true,
    component: PreLoginConsent,
    excludeFromSidebar: true,
  },
  {
    id: 'pre-login',
    path: '/auth/pre-login',
    name: 'Pre Login',
    exact: true,
    component: PreLogin,
    excludeFromSidebar: true,
  },
  {
    id: 'family-login-success',
    path: '/auth/login-success',
    name: 'Family Login Success',
    exact: true,
    component: FamilyLoginSuccess,
    excludeFromSidebar: true,
  },
  {
    id: 'terms-conditions',
    path: '/general/tnc',
    exact: true,
    name: 'Terms and Conditions',
    component: TermsConditions,
    excludeFromSidebar: true,
  },
  {
    id: 'privacy-policy',
    path: '/general/privacy-policy',
    exact: true,
    name: 'Privacy Policy',
    component: PrivacyPolicy,
    excludeFromSidebar: true,
  },
  {
    id: 'refund-policy',
    path: '/general/refund-policy',
    exact: true,
    name: 'Refund Policy',
    component: RefundPolicy,
    excludeFromSidebar: true,
  },
  {
    id: 'customer-support',
    path: '/general/customer-support',
    exact: true,
    name: 'Customer support',
    component: CustomerSupport,
    excludeFromSidebar: true,
  },
  {
    id: 'order-book',
    path: '/order-book',
    name: 'Orderbook',
    component: userOrderBookIndexPage,
    exact: true,
    icon: OrderBookOutlineIcon,
  },
  {
    id: 'notifications',
    path: '/alerts',
    name: 'Alerts',
    component: React.lazy(() =>
      import(/* webpackChunkName: "notifications" */ './pages/Notifications')
    ),
    exact: true,
    icon: NotificationsActiveOutlinedIcon,
    excludeFromSidebar: true,
  },
  {
    id: 'reports',
    path: '/reports',
    name: 'Reports',
    component: Reports,
    exact: true,
    icon: BarChartOutlinedIcon,
  },
  {
    id: 'notification-alerts',
    path: '/announcements',
    exact: true,
    name: 'Announcements',
    component: NotificationAlerts,
    excludeFromSidebar: true,
  },
  {
    id: 'brokers',
    path: '/broker-login',
    exact: true,
    name: 'Brokers',
    component: Brokers,
    excludeFromSidebar: true,
  },
  {
    id: 'algo-bulk-error-retry',
    path: '/algo-bulk-error-retry',
    exact: true,
    name: 'AlgoBulkErrorRetry',
    component: AlgoBulkErrorRetry,
    excludeFromSidebar: true,
  },
  {
    id: 'not-found',
    component: NotFound,
    excludeFromSidebar: true,
  },
];

export default routes;
